var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const setInterceptors = (axios) => {
    axios.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
        const configuration = config;
        const token = localStorage.getItem('session');
        configuration.headers = Object.assign(Object.assign({}, configuration.headers), { Authorization: token ? `Bearer ${token}` : '' });
        return configuration;
    }));
    return axios;
};
export default setInterceptors;
